// extracted by mini-css-extract-plugin
export default {"copyRow":"Copyright_copyRow__dF28h","links":"Copyright_links__kLchm"};